import { parseToApiDate, prepareCoordinates } from './react';
import { SchemaCreateNewBasketRequestBody } from '@repo/legacy-commerce-api';

export const prepareFiltersPayload = (locations, startDate, duration, industry, formats, filterNames) => {
  return {
    filtername: [...filterNames],
    criteria: {
      availability: {
        startdate: parseToApiDate(startDate),
        duration: duration,
      },
      city: Object.keys(locations)
        .map((locKey) => {
          if (locations[locKey].types?.includes('locality')) {
            return {
              name: locations[locKey].address,
              longitude_x: locations[locKey].lngLtd?.lng || locations[locKey].longitude,
              latitude_y: locations[locKey].lngLtd?.lat || locations[locKey].latitude,
            };
          } else return null;
        })
        .filter((el) => el !== null),
      coordinate: Object.keys(locations)
        .map((locKey) => {
          if (!locations[locKey].types?.includes('locality')) {
            return {
              radius: locations[locKey].circle?.radius,
              longitude_x: locations[locKey].lngLtd?.lng || locations[locKey].longitude,
              latitude_y: locations[locKey].lngLtd?.lat || locations[locKey].latitudet,
            };
          } else return null;
        })
        .filter((el) => el !== null),
      industry: industry,
      format: formats,
    },
  };
};

export const prepareProposalsPayload = (data) => {
  return {
    coordinates: prepareCoordinates(data.locations),
    budget: data.budget,
    dateaccurancy: data.dateAccuracy,
    startdate: new Date(data.startDate).toISOString(),
    duration: data.duration,
    industry: data.industry,
    digital: data.digital,
  };
};

export const prepareCreateBasketPayload = (
  name: string,
  industry: string,
  _startdate: any,
  _category?: any,
): SchemaCreateNewBasketRequestBody => {
  return {
    name: name,
    industry: industry,
    category: 1,
  };
};

export const prepareAddAllToBasketPayload = (basket, reference, startDate, duration, producturns, industry) => ({
  basket,
  basketreference: reference,
  startdate: startDate,
  duration,
  industry,
  producturns,
  autocorrectstartdate: 1,
});

export const prepareAddToBasketPayload = (
  basket,
  reference,
  startDate,
  duration,
  product,
  industry,
  timeslot?,
  spotlength?,
  shareoftime?,
  budget?,
) => {
  let result = {
    basket: basket,
    basketreference: reference,
    startdate: startDate,
    duration: duration,
    industry: industry,
    producturns: [product],
    autocorrectstartdate: 1,
  };

  if (timeslot) {
    result['timeslot'] = timeslot;
  }
  if (spotlength) {
    result['spotlength'] = spotlength;
  }
  if (shareoftime) {
    result['shareoftime'] = shareoftime;
  }
  if (budget) {
    result['budget'] = budget;
  }
  return result;
};

export const prepareUpdateBasketEntryPayload = (
  basket,
  reference,
  startDate,
  duration,
  timeslot?,
  spotlength?,
  shareoftime?,
  budget?,
) => {
  let result = {
    basket: basket,
    basketreference: reference,
    startdate: startDate,
    duration: duration,
  };

  if (timeslot) {
    result['timeslot'] = timeslot;
  }
  if (spotlength) {
    result['spotlength'] = spotlength;
  }
  if (shareoftime) {
    result['shareoftime'] = shareoftime;
  }
  if (budget) {
    result['budget'] = budget;
  }
  return result;
};
